import {Accordion, AccordionDetails, AccordionSummary, Typography} from "@mui/material"
import {ExpandMore as ExpandMoreIcon, AssignmentInd as InfoIcon} from "@mui/icons-material"
import React from "react"

import {
	CustomerInformationUpdatedActivityPayload,
	CustomerInformationUpdatedByCustomerActivityPayload,
} from "@indebted/api"

function InformationUpdatedActivity(
	panelId: number,
	{
		Title,
		HappenedAt,
		Payload,
	}: {
		Title: string
		HappenedAt: string
		Payload: CustomerInformationUpdatedActivityPayload | CustomerInformationUpdatedByCustomerActivityPayload
	},
	expanded: boolean,
	handleExpand: (panelID: number) => (event: any, isExpanded: boolean) => void,
	classes: {summary: string; activityContent: string; activityContentLabel: string; activityContentValue: string},
) {
	return (
		<Accordion expanded={expanded} onChange={handleExpand(panelId)}>
			<AccordionSummary expandIcon={<ExpandMoreIcon />}>
				<InfoIcon color="primary" />
				<Typography className={classes.summary}>
					{" "}
					<b>{Title}</b> - {HappenedAt}
				</Typography>
			</AccordionSummary>
			<AccordionDetails>
				{expanded && (
					<div className={classes.activityContent}>
						<div>
							<Typography className={classes.activityContentLabel}>Name:</Typography>
							<Typography className={classes.activityContentValue}>{Payload.Name}</Typography>
						</div>
						<div>
							<Typography className={classes.activityContentLabel}>Date of Birth:</Typography>
							<Typography className={classes.activityContentValue}>{Payload.DOB}</Typography>
						</div>
					</div>
				)}
			</AccordionDetails>
		</Accordion>
	)
}

export {InformationUpdatedActivity}
